$(window).load(function() {
    $(".wrapper").css('opacity','1');
});

$(function () {
   let slider = $('#slider1,#slider2,#slider3');
   slider.slick({
       infinite: true,
       slidesToShow: 1,
       fade: true,
       arrows: false,
       dots: false
   });
});

// $(function () {
//     let slider = $('#slider3');
//     slider.slick({
//         infinite: true,
//         slidesToShow: 1,
//         fade: true,
//         autoplay: true,
//         autoplaySpeed:4000,
//         speed:800,
//         arrows: false,
//         dots: false
//     });
// });

function slideGo(dir) {
 let slider = $('#slider1');
   if(dir === "+") {
       slider.slick('slickNext');
   } else if ( dir === "-" ) {
       slider.slick('slickPrev');
   }
}

function slideGo2(dir) {
 let slider = $('#slider2');
   if(dir === "+") {
       slider.slick('slickNext');
   } else if ( dir === "-" ) {
       slider.slick('slickPrev');
   }
}

function slideGo3(dir) {
 let slider = $('#slider3');
   if(dir === "+") {
       slider.slick('slickNext');
   } else if ( dir === "-" ) {
       slider.slick('slickPrev');
   }
}

$('.brtspr .Member_Product_Table tr').each(function() {

   var value = $(this).children('.value1').attr('data-value2');
   var name = $(this).closest("tr").attr('id');
   var subtotal = $("#"+name+'> td.value').attr('data-value');
   var linetotal = ( value - subtotal);
   $("#"+name + "> td.subtotal").text("$" + linetotal.toFixed(2) ).attr('data-value', linetotal.toFixed(2));

   var grandTotal = 0;

   $('.subtotal').each(function(){
       var rowTotal = parseFloat($(this).attr('data-value'));
       grandTotal = rowTotal + grandTotal;
       $("td.grandTotal").text("$" + grandTotal.toFixed(2) + "");        
   });

})

$(document).ready(function(){

   $(".value1").each(function() {
       calculateSum();
   });

   $(".value").each(function() {
       calculateSum2();
   });
});

function calculateSum() {
   var sum = 0;
   //iterate through each textboxes and add the values
   $(".value1").each(function() {
       var value = $(this).attr('data-value2');
       //add only if the value is number
       if(!isNaN(value) && value.length!=0) {
           sum += parseFloat(value);
       }

   });
   //.toFixed() method will roundoff the final sum to 2 decimal places
   $("#sum").html(sum.toFixed(2));
}

function calculateSum2() {
   var sum = 0;
   //iterate through each textboxes and add the values
   $(".value").each(function() {
       var value = $(this).attr('data-value');
       //add only if the value is number
       if(!isNaN(value) && value.length!=0) {
           sum += parseFloat(value);
       }

   });
   //.toFixed() method will roundoff the final sum to 2 decimal places
   $("#sum2").html(sum.toFixed(2));
}


$('.brtspr .accord_title').click(function(){
   $('.brtspr .accord_content').not($(this).next()).slideUp();
   $(this).parent().siblings().children().removeClass('active');
   $(this).next().slideToggle();
   $(this).toggleClass('active');
});


$(".brtspr .accord_title:eq(0)").trigger( "click" );

$("body").on("click",".open-login-modal",function(e){
    e.preventDefault();
    $('#login-modal').addClass('open');
    $('#login-modal').fadeIn();
    $('body').addClass('modal-open');
});